import { styled } from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.horizontalSpacingM};
  padding-top: ${({ theme }) => theme.spacing.verticalSpacingXL};
  padding-bottom: ${({ theme }) => theme.spacing.verticalSpacingXL};
  border-top: 1px solid ${({ theme }) => theme.colors.textAndBackgroundLightGrey};
  border-bottom: 1px solid ${({ theme }) => theme.colors.textAndBackgroundLightGrey};
`

export const QRContainer = styled.div<{ $deg: number }>`
  position: relative;
  min-width: 100px;
  max-width: 150px;
  width: 32%;
  height: auto;
  aspect-ratio: 1/1;
  border-radius: 8px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    top: 50%;
    left: 50%;
    translate: -50% -50%;
    border-radius: 8px;
    z-index: -1;
    background-image: conic-gradient(from ${({ $deg }) => $deg}deg, transparent 50%, #f88d2a);
  }
`

export const ImageQRCode = styled.div<{ $backgroundImage: string }>`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
  background-image: url(${({ $backgroundImage }) => `"${$backgroundImage}"`});
  background-size: 120%;
  background-position: center;
`
